<template>
  <div id="app">
    <template v-if="startShow">
      <!-- ccb顶部标题 -->
      <div class="ccb-top-title" v-if="isCcb">
        <div>
          <span class="icon" @click="miniappReturn" v-show="prview"></span>
        </div>
        <span class="title">{{ "体检预约" }}</span>
        <em></em>
      </div>
      <!--  -->
      <!-- <div class="mark">{{mark}}</div> -->
      <!--标题栏-->
      <TitleBarV1
        v-if="showTitleBar"
        ref="TitleBarV1"
        :data="$route.meta.titleBar"
      ></TitleBarV1>
      <!-- 这里是会被缓存的视图组件，比如 Home！ -->
      <keep-alive>
        <router-view
          v-if="$route.meta.keepAlive"
          :key="$route.fullPath"
          :class="{ 'show-title-bar': showTitleBar }"
          @setSubTitle="setSubTitle"
        ></router-view>
      </keep-alive>
      <!-- 这里是不被缓存的视图组件，比如 Edit！ -->
      <router-view
        v-if="!$route.meta.keepAlive"
        :key="$route.fullPath"
        :class="{ 'show-title-bar': showTitleBar }"
        @setSubTitle="setSubTitle"
      ></router-view>
      <div
        @click="backToTop"
        class="fixed_btn webview-top webview-animateHide"
      ></div>
    </template>
  </div>
</template>

<script>
import {
  getUrlParams,
  getUrlSpecifiedParam,
  loadJs,
  synchronizedPackageHistory,
  wechatShare
} from "@/assets/js/util";
import { http, HTTP_URL, getCityId } from "@/assets/js/api";
import TitleBarV1 from "@/components/common/TitleBarV1"; // 个检顶部标题栏
// import PullDownContainer from '@/components/common/PullDownContainer'
// import PullDownLoading from '@/components/common/PullDownLoading'
import * as types from "@/store/mutation-types";

export default {
  name: "app",
  components: {
    TitleBarV1
    // PullDownContainer,
    // PullDownLoading
  },
  data() {
    return {
      requestIng: false,
      transitionName: "",
      currentTitle: "",
      prview: false,
      startShow: false,
      timer: null,
      isCcb
      // isPullingDown: false
      // authNeed: false,
    };
  },
  computed: {
    showTitleBar() {
      return (
        this.$route.meta.titleBar &&
        this.$route.meta.titleBar.show &&
        this.$route.query.is_company !== "1" &&
        ENTRY_CHANNEL[sessionStorage.getItem("channel")] !== "掌铁"
      );
    },
    mark() {
      return "新版";
    }
  },
  methods: {
    // onRefresh() {
    //   this.isPullingDown = true
    //   console.log('App组件 下拉刷新')
    // },
    init() {
      // 如果是中台跳过来，要先把转city_id才能开始加载项目
      this.timer = setTimeout(() => {
        this.startApp();
      }, 3000);
      if (
        this.$store.state.comefrom &&
        localStorage.getItem("myLocationInfo") &&
        sessionStorage.getItem("comefrom") !== "pocketInfirmarySystem"
      ) {
        let city = JSON.parse(localStorage.getItem("myLocationInfo"));
        if (city.area_code) {
          http({
            url: HTTP_URL.getByAreaCode,
            params: {
              area_code: city.area_code
            },
            prefix: appPath
          })
            .then(res => {
              city = {
                ...city,
                ...{ city_id: res[0].id }
              };
              // localStorage.setItem("myLocationInfo", JSON.stringify(city));
              this.$store.dispatch("saveCity", city);
              setTimeout(() => {
                this.startApp();
              }, 200);
            })
            .catch(() => {
              startApp();
            });
        } else {
          this.startApp();
        }
      } else if (this.getCityName()) {
      } else {
        this.startApp();
      }
      if (sessionStorage.getItem("comefrom") === "pocketInfirmarySystem") {
        this.initPocket();
      }
    },
    //   口袋填充信息
    initPocket() {
      const name = getUrlSpecifiedParam("name");
      const mobile = getUrlSpecifiedParam("mobile");
      const certNo = getUrlSpecifiedParam("certNo");
      const isPerson = getUrlSpecifiedParam("isPerson");
      if (name || mobile || certNo) {
        const obj = {
          name: decodeURIComponent(name) || "",
          mobile: decodeURIComponent(mobile) || "",
          certNo: decodeURIComponent(certNo) || ""
        };
        sessionStorage.setItem("pocketUserInfo", JSON.stringify(obj));
      }
      sessionStorage.setItem("isPerson", isPerson ? isPerson : "");
      //   this.$store.commit(types.SET_DEFAULT_FORM_DATA, obj);
    },

    // url 上带了city_name
    getCityName() {
      let cityName = getUrlSpecifiedParam("city_name");
      if (cityName) {
        cityName = decodeURIComponent(cityName);
        cityName =
          cityName.length < 3
            ? cityName
            : cityName.substr(0, cityName.length - 1);

        getCityId(this, cityName).then(response => {
          if (response.code == 200 && JSON.stringify(response.data) !== "[]") {
            var info = {
              city_name: cityName,
              city_id: response.data.id,
              area_code: response.data.standard_code,
              date: Math.floor(new Date().getTime() / 1000)
            };
            sessionStorage.setItem("myLocationInfo", JSON.stringify(info));
            localStorage.setItem("myLocationInfo", JSON.stringify(info));
            this.$store.dispatch("saveCity", info);
            this.startApp();
          } else {
            this.startApp();
          }
        });
        return true;
      }
      return false;
    },

    startApp() {
      this.startShow = true;
      clearTimeout(this.timer);
    },
    hasAssign() {
      // 兼容某些老机型不支持assign方法
      if (typeof Object.assign !== "function") {
        // Attention 1
        Object.defineProperty(Object, "assign", {
          value: function(target) {
            "use strict";
            if (target == null) {
              // Attention 2
              throw new TypeError("Cannot convert undefined or null to object");
            }

            // Attention 3
            var to = Object(target);

            for (var index = 1; index < arguments.length; index++) {
              var nextSource = arguments[index];

              if (nextSource != null) {
                // Attention 2
                // Attention 4
                for (var nextKey in nextSource) {
                  if (
                    Object.prototype.hasOwnProperty.call(nextSource, nextKey)
                  ) {
                    to[nextKey] = nextSource[nextKey];
                  }
                }
              }
            }
            return to;
          },
          writable: true,
          configurable: true
        });
      }
    },
    miniappReturn() {
      if (
        getUrlParams(window.location.href)["backUrl"] &&
        getUrlParams(window.location.href)["backUrl"] == "index"
      ) {
        this.$router.push("/");
        return;
      }
      this.$router.back(-1);
    },
    backToTop(rate) {
      var doc = document.body.scrollTop
        ? document.body
        : document.documentElement;
      var scrollTop = doc.scrollTop;
      var top = function() {
        scrollTop = scrollTop + (0 - scrollTop) / 2;
        // 临界判断，终止动画
        if (scrollTop < 1) {
          doc.scrollTop = 0;
          $(".webview-top").addClass("webview-animateHide");
          return;
        }
        doc.scrollTop = scrollTop;
        // 动画gogogo!
        requestAnimationFrame(top);
      };
      top();
    },
    pageInit() {
      let html = $("html");
      isAndroid && html.addClass("android"); // 是否安卓
      isIOS && html.addClass("ios"); // 是否IOS
      isWechat && html.addClass("wechat"); // 是否微信浏览器
      isAlipay && html.addClass("alipay"); // 是否支付宝浏览器
      // 是否机构公众号
      let channel =
        getUrlSpecifiedParam("channel") || sessionStorage.getItem("channel");

      let channelOrgInfoId = getUrlSpecifiedParam("channelOrgInfoId");
      // 001_05为代运营的公众号，需要隐藏袋鼠品牌
      // 还有机构不好改url的做临时处理放在下面
      let orgsUrl = [
        "https://apps.daishutijian.com/wechat/h5#/org-detail/1745?city_id=115",
        "https://apps.daishutijian.com/wechat/h5#/org-detail/1536?city_id=184"
      ];
      if (
        orgsUrl.indexOf(document.URL) !== -1 ||
        (channel && channel.slice(0, 6) === "001_05") ||
        sessionStorage.getItem("wechat-subscription") === "true"
      ) {
        html.addClass("wechat-subscription");
        sessionStorage.setItem("wechat-subscription", "true");
        channel &&
          !sessionStorage.getItem("channel") &&
          sessionStorage.setItem("channel", channel);
        // 缓存机构渠道分享的信息
        channelOrgInfoId && this.getOrgDetail(channelOrgInfoId);
        isWechatSubscription = true; // 是否公众号标识
      }

      // 条件为公众号地址，且地址不为袋鼠官方地址
      // if (
      //   ((channel.indexOf('001_01_') !== -1 || isOrg == '1') &&
      //     channel.indexOf('001_01_0001_0000_00')) ||
      //   sessionStorage.getItem('wechat-subscription') === 'true' ||
      //   window.location.href === 'https://apps.daishutijian.com/wechat/h5#/org-detail/1745?city_id=115'
      // ) {
      // }
    },
    getOrgDetail(id) {
      // sessionStorage没有该机构数据时，重新请求数据
      let params = { org_id: id };
      http({
        url: HTTP_URL.getOrgDetail,
        params
      }).then(res => {
        if (res.code === 200) {
          // 缓存分享的信息
          sessionStorage.setItem(
            "channelOrgInfo",
            JSON.stringify({
              name: res.result.name || "机构主页",
              img:
                document.URL.indexOf("apps.") === -1
                  ? "https:" + websit_path + res.result.small_pic_url
                  : websit_path + res.result.small_pic_url,
              org_id: res.result.id
            })
          );
          wechatShare({
            title: res.result.name,
            desc: "体检预约",
            link: document.URL,
            imgUrl:
              document.URL.indexOf("apps.") === -1
                ? "https:" + websit_path + res.result.small_pic_url
                : websit_path + res.result.small_pic_url,
            implementRequest: true // 是否重新获取设置分享配置
          });
        }
      });
    },
    setSubTitle(title) {
      this.$refs.TitleBarV1 && (this.$refs.TitleBarV1.title = title);
      // 医院入口则要修改title
      if (isWechatSubscription && title) {
        document.title = title;
      }
    }
  },
  created() {
    this.init();
  },
  mounted() {
    this.$nextTick(() => {
      this.hasAssign();
      this.pageInit();
      window.onload = function() {
        var jsList = [];
        if (
          user_id &&
          TESTUSERID &&
          TESTUSERID.indexOf(Number(user_id)) !== -1
        ) {
          // 添加开发者调试工具
          // if( true) { //添加开发者调试工具
          jsList.push({
            url: appPath + "resource/js/vconsole.min.js",
            callback: function() {
              // new VConsole();
            }
          });
        }

        for (var i = 0; i < jsList.length; i++) {
          loadJs({
            url: jsList[i].url,
            params: jsList[i].params,
            callback: jsList[i].callback
          });
        }
      };
    });
  },
  watch: {
    $route(to, from) {
      // 套餐列表与机构列表给html添加类来控制层级样式
      if (
        to.name === "packageListV2" ||
        to.name === "orgListV2" ||
        to.name === "package-org-v2"
      ) {
        $("html").addClass("z-index-flag");
      } else {
        $("html").addClass("z-index-flag");
      }
      // 路由改变时，清空副标题
      if (to.name !== from.name) {
        this.setSubTitle("");
      }
      this.currentTitle = to.meta.title;
      var vm = this;
      this.prview = isCcb && history.length >= 2 && to.name != "index";
      // web-view 后退按钮
      // checkWebview(res => {
      //   if (to.name != "index1" && history.length >= 2) {
      //     //是否建行或小程序或首页
      //     if (res || isCcb) {
      //       $(".miniapp-history").show();
      //     }
      //   } else {
      //     $(".miniapp-history").hide();
      //   }
      // });
      // 4324234
      const toDepth = to.path.split("/").length;
      const fromDepth = from.path.split("/").length;
      if (toDepth < fromDepth) {
        // this.transitionName = "slide-right";
        this.transitionName = "";
      } else if (toDepth == fromDepth) {
        this.transitionName = "";
      } else {
        this.transitionName = "slide-left";
      }
      synchronizedPackageHistory();
    }
  }
};
</script>

<style lang="less">
// @import "assets/css/variable";
@import "assets/css/index";
@import "assets/css/variable";
@import "assets/css/theme/theme-ccb";
@import "assets/css/theme/theme-shenda";
@import "assets/css/theme/theme-baojiankang";
@import "assets/css/theme/theme-nanhang";
@import "assets/css/theme/theme-huada";
@import "assets/css/theme/theme-daishu";
//ccb 建行样式
@import "assets/css/wechat-subscription";
//ccb 建行样式
@import "assets/css/daishuUI"; //daishu-ui样式
@image: "./assets/fonts/";
@images: "./assets/images/";

// 解决百度地图定位创建iframe时导致页面跳动问题
iframe {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  pointer-events: none;
}

// 避免覆盖在线客服的iframe样式
#chatIframe {
  position: relative;
  left: auto;
  top: auto;
  opacity: 1;
  pointer-events: inherit;
}

//覆盖mit-ui弹窗颜色
.confirmBtn {
  color: @color-theme !important;
}

.mint-msgbox-title {
  font-size: 0.14rem !important;
  font-weight: 400 !important;
  padding: 0 0.2rem !important;
}

/*.slide-right-enter-active,*/
/*.slide-right-leave-active,*/
/*.slide-left-leave-active,*/
/*.slide-left-enter-active {*/
/*position: fixed;*/
/*top: 0;*/
/*bottom: 0;*/
/*left: 0;*/
/*right: 0;*/
/*z-index: 30;*/
/*transition: all 0.5s;*/
/*}*/
/*// .slide-left-enter,*/
/*.slide-left-leave-to {*/
/*transform: translate3d(-100%, 0, 0);*/
/*z-index: 40;*/
/*}*/
/*.slide-right-leave,*/
/*.slide-left-leave {*/
/*z-index: 40;*/
/*}*/
/*.slide-right-leave-to {*/
/*z-index: 40;*/
/*transform: translate3d(100%, 0, 0);*/
/*}*/

@font-face {
  font-family: HelveticaNeueLTPro_BdCn;
  src: url("@{image}HelveticaNeueLTPro-BdCn.otf");
}

#app {
  // min-width: 320px;
}

.bscroll-vertical-scrollbar .bscroll-indicator {
  opacity: 0.5;
}

.Tips {
  position: fixed;
  top: 0;
  transform: translate3d(0, -0.4rem, 0);
  transition: all 0.3s;
  text-align: center;
  width: 100%;
  height: 80/200rem;
  line-height: 80/200rem;
  background-color: rgba(0, 0, 0, 0.8);
  color: #fff;
  z-index: 9999;
}

.showTips {
  transform: translate3d(0, 0, 0);
  transition: all 0.3s;
}

.arrow {
  display: inline-block;
  transition: all 0.2s;
  height: 6/100rem;
  width: 6/100rem;
  border-width: 1px 1px 0 0;
  border-color: #e0e0e0;
  border-style: solid;
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, -2) rotate(0);
}

.arrow-right {
  transform: matrix(0.71, 0.71, -0.71, 0.71, 0, -2) rotate(0deg);
}

.fixed_btn {
  display: none;
  width: 84/200rem;
  height: 84/200rem;
  border-radius: 50%;
  background-size: cover;
  right: 30/200rem;
  position: fixed;
  opacity: 1;
  transition: all 0.2s;
}

.miniapp-history {
  display: none;
  bottom: 148/200rem;
  background-image: url("@{images}webview-back.png");
}

.webview-top {
  bottom: 252/200rem;
  background-image: url("@{images}webview-top.png");
}

.webview-animateHide {
  visibility: hidden;
  opacity: 0;
}

.swiper-pagination {
  padding-right: 12/200rem;
  text-align: right !important;

  .swiper-pagination-bullet {
    width: 8px !important;
    height: 8px !important;
    margin: 0 4/200rem !important;
    border-radius: 50% !important;
    background-color: #666 !important;
    opacity: 0.5 !important;
    transform: scale3d(0.75, 0.75, 0.75);
    transition: all 0.15s;
  }

  .swiper-pagination-bullet-active {
    background-color: #666;
    opacity: 1 !important;
    transform: scale3d(1, 1, 1);
  }
}

//iphonex 兼容写法
@media only screen and (device-width: 375px) and (device-height: 812px) and (-webkit-device-pixel-ratio: 3) {
  #app {
    box-sizing: border-box;
    padding-bottom: 34px;
  }

  /*导航操作栏上移*/
  #footer,
  .ipx-fixed-footer,
  #pay-detail-total {
    padding-bottom: 34px;
    background-color: #fff;
    height: auto;
  }

  #authorization-active {
    padding: 46/200rem 0 212/200rem 0;
  }

  #submit-wrapper {
    height: 0.77rem;
  }

  #submit {
    height: 0.78rem;
  }

  #submit div {
    line-height: 0.78rem;
  }
}

@media only screen and (device-width: 414px) and (device-height: 896px) and (-webkit-device-pixel-ratio: 3) {
  #app {
    box-sizing: border-box;
    padding-bottom: 34px;
  }

  /*导航操作栏上移*/
  #footer,
  .ipx-fixed-footer,
  #pay-detail-total {
    padding-bottom: 34px;
    background-color: #fff;
    height: auto;
  }

  #authorization-active {
    padding: 46/200rem 0 212/200rem 0;
  }

  #submit-wrapper {
    height: 0.77rem;
  }

  #submit {
    height: 0.78rem;
  }

  #submit div {
    line-height: 0.78rem;
  }
}

// cude ui的 toast样式
.cube-toast-tip {
  padding: 10/100rem 10/100rem;
  background: rgba(0, 0, 0, 0.5);
  border-radius: 4/100rem;
  color: #fff;
}

.show-title-bar:before {
  content: "";
  display: block;
  width: 100%;
  height: 80/200rem;
}
.z-index-flag {
  &.show-popup #app {
    .sortbar-container {
      z-index: 9999;
    }
  }
  #app .title-bar-v1 {
    z-index: 2002;
  }
}
.show-dropdown {
  #app .title-bar-v1 {
    z-index: 2002;
  }
}
.show-city-toggle {
  #app .title-bar-v1 {
    .icon-menu {
      opacity: 0;
      pointer-events: none;
    }
  }
}

// minui swich 样式兼容
.mint-switch {
  .mint-switch-core {
    height: 25px;
  }
  .mint-switch-core::before,
  .mint-switch-core::after {
    height: 23px;
  }
  .mint-switch-input:checked + .mint-switch-core {
    border-color: @color-theme;
    background-color: @color-theme;
  }
}
.mark {
  position: fixed;
  bottom: 150px;
  background: pink;
  z-index: 100;
  right: 10px;
  border-radius: 5px;
  padding: 10px;
  opacity: 0.8;
}
</style>
